// extracted by mini-css-extract-plugin
module.exports = {"logoblock":"resources_logoblock__3CKVH","textblock":"resources_textblock__3kicV","divider":"resources_divider__1ybGR"};